    // Global script for White Glove Service automation
    (function () {
      const PREMIUM_SERVICE_HANDLE = 'smart-ease-cushion-app-remote-monitoring';
      const CUSHION_HANDLES = ['ease-cushion', 'ease-cushion-gen-2'];
      let isProcessing = false;
      let lastCartState = null;

      // Function to get premium service variant ID
      async function getPremiumServiceVariantId() {
        try {
          const response = await fetch(`/products/${PREMIUM_SERVICE_HANDLE}.js`);
          const product = await response.json();
          return product.variants[0].id;
        } catch (err) {
          console.error('Error getting premium service variant:', err);
          return null;
        }
      }

      // Function to check if cart has cushions
      function hasCushionInCart(cart) {
        return cart.items.some((item) => CUSHION_HANDLES.includes(item.handle));
      }

      // Function to check if cart has premium service
      function hasPremiumServiceInCart(cart) {
        return cart.items.some((item) => item.handle === PREMIUM_SERVICE_HANDLE);
      }

      // Function to get premium service line item key
      function getPremiumServiceKey(cart) {
        const item = cart.items.find((item) => item.handle === PREMIUM_SERVICE_HANDLE);
        return item ? item.key : null;
      }

      // Function to add premium service to cart
      async function addPremiumService() {
        if (isProcessing) return;
        isProcessing = true;

        try {
          const variantId = await getPremiumServiceVariantId();
          if (!variantId) {
            isProcessing = false;
            return;
          }

          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              items: [
                {
                  id: variantId,
                  quantity: 1,
                },
              ],
            }),
          });

          if (response.ok) {
            console.log('White Glove Service added successfully');
            // Trigger cart update events
            document.dispatchEvent(new CustomEvent('cart:updated'));
            document.dispatchEvent(new CustomEvent('cart:refresh'));

            // Update mini cart if available
            if (typeof window.refreshCart === 'function') {
              window.refreshCart();
            }
          }
        } catch (err) {
          console.error('Error adding premium service:', err);
        } finally {
          isProcessing = false;
        }
      }

      // Function to remove premium service from cart
      async function removePremiumService(cart) {
        if (isProcessing) return;
        isProcessing = true;

        try {
          const serviceKey = getPremiumServiceKey(cart);
          if (!serviceKey) {
            isProcessing = false;
            return;
          }

          const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: serviceKey,
              quantity: 0,
            }),
          });

          if (response.ok) {
            console.log('White Glove Service removed successfully');
            // Trigger cart update events
            document.dispatchEvent(new CustomEvent('cart:updated'));
            document.dispatchEvent(new CustomEvent('cart:refresh'));

            // Update mini cart if available
            if (typeof window.refreshCart === 'function') {
              window.refreshCart();
            }
          }
        } catch (err) {
          console.error('Error removing premium service:', err);
        } finally {
          isProcessing = false;
        }
      }

      // Main function to manage white glove service
      async function manageWhiteGloveService() {
        if (isProcessing) return;

        try {
          const response = await fetch('/cart.js');
          const cart = await response.json();

          const hasCushion = hasCushionInCart(cart);
          const hasService = hasPremiumServiceInCart(cart);

          // Check if cart state changed
          const currentCartState = JSON.stringify({ hasCushion, hasService, itemCount: cart.item_count });
          if (currentCartState === lastCartState) {
            return;
          }
          lastCartState = currentCartState;

          console.log('Cart state:', { hasCushion, hasService });

          // If there's a cushion but no service, add it
          if (hasCushion && !hasService) {
            console.log('Adding White Glove Service...');
            await addPremiumService();
          }
          // If there's no cushion but there's a service, remove it
          else if (!hasCushion && hasService) {
            console.log('Removing White Glove Service...');
            await removePremiumService(cart);
          }
        } catch (err) {
          console.error('Error managing white glove service:', err);
        }
      }

      // Function to check if cart has only the premium service (no real products)
      async function isCartOnlyService() {
        try {
          const response = await fetch('/cart.js');
          const cart = await response.json();
          const hasService = hasPremiumServiceInCart(cart);
          const hasOtherProducts = cart.items.some((item) => item.handle !== PREMIUM_SERVICE_HANDLE);
          return hasService && !hasOtherProducts;
        } catch (err) {
          console.error('Error checking cart:', err);
          return false;
        }
      }

      // Function to prevent checkout if only premium service in cart
      function preventCheckoutIfOnlyService() {
        fetch('/cart.js')
          .then((response) => response.json())
          .then((cart) => {
            const hasService = hasPremiumServiceInCart(cart);
            const hasOtherProducts = cart.items.some((item) => item.handle !== PREMIUM_SERVICE_HANDLE);

            // If only service in cart, disable checkout
            if (hasService && !hasOtherProducts) {
              const checkoutButtons = document.querySelectorAll(
                '[name="checkout"], .cart__checkout-button, button[type="submit"][name="checkout"], [href*="/checkout"]'
              );
              checkoutButtons.forEach((btn) => {
                btn.disabled = true;
                btn.style.opacity = '0.5';
                btn.style.cursor = 'not-allowed';
                btn.title = 'The App cannot be purchased alone. Please add a cushion to your cart.';
                // Remove href for links to prevent navigation
                if (btn.tagName === 'A') {
                  btn.dataset.originalHref = btn.href;
                  btn.removeAttribute('href');
                }
              });
            } else {
              // Re-enable checkout buttons
              const checkoutButtons = document.querySelectorAll(
                '[name="checkout"], .cart__checkout-button, button[type="submit"][name="checkout"], [data-original-href]'
              );
              checkoutButtons.forEach((btn) => {
                btn.disabled = false;
                btn.style.opacity = '1';
                btn.style.cursor = 'pointer';
                btn.title = '';
                // Restore href for links
                if (btn.dataset.originalHref) {
                  btn.href = btn.dataset.originalHref;
                  delete btn.dataset.originalHref;
                }
              });
            }
          })
          .catch((err) => console.error('Error checking cart for checkout:', err));
      }

      // Block form submissions when only service in cart
      document.addEventListener('submit', async function(e) {
        const form = e.target;
        // Check if this is a checkout form
        if (form.action && (form.action.includes('/checkout') || form.action.includes('/cart'))) {
          const onlyService = await isCartOnlyService();
          if (onlyService) {
            e.preventDefault();
            e.stopPropagation();
            alert('The App cannot be purchased alone. Please add a cushion to your cart first.');
            return false;
          }
        }
      }, true);

      // Block direct navigation to checkout
      document.addEventListener('click', async function(e) {
        const link = e.target.closest('a[href*="/checkout"]');
        if (link) {
          const onlyService = await isCartOnlyService();
          if (onlyService) {
            e.preventDefault();
            e.stopPropagation();
            alert('The App cannot be purchased alone. Please add a cushion to your cart first.');
            return false;
          }
        }
      }, true);

      // Block checkout page access - redirect away if only service in cart
      if (window.location.pathname.includes('/checkout')) {
        isCartOnlyService().then((onlyService) => {
          if (onlyService) {
            alert('The App cannot be purchased alone. Please add a cushion to your cart first.');
            window.location.href = '/cart';
          }
        });
      }

      // Listen for all cart-related events
      document.addEventListener('cart:updated', () => {
        setTimeout(manageWhiteGloveService, 500);
        setTimeout(preventCheckoutIfOnlyService, 700);
      });

      document.addEventListener('cart:refresh', () => {
        setTimeout(manageWhiteGloveService, 500);
        setTimeout(preventCheckoutIfOnlyService, 700);
      });

      document.addEventListener('cart:change', () => {
        setTimeout(manageWhiteGloveService, 500);
        setTimeout(preventCheckoutIfOnlyService, 700);
      });

      // Listen for product form submissions
      document.addEventListener('submit', function (e) {
        if (e.target.matches('form[action*="/cart/add"]') || e.target.matches('product-form')) {
          setTimeout(manageWhiteGloveService, 1000);
        }
      });

      // Check on page load
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
          setTimeout(manageWhiteGloveService, 1000);
          setTimeout(preventCheckoutIfOnlyService, 1200);
        });
      } else {
        setTimeout(manageWhiteGloveService, 1000);
        setTimeout(preventCheckoutIfOnlyService, 1200);
      }

      // Polling (checks every 3 seconds)
      setInterval(() => {
        manageWhiteGloveService();
        preventCheckoutIfOnlyService();
      }, 3000);
    })();
